<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-toolbar class="md-primary">
        <h3 class="md-title">{{ $t("Canada Flight Supplement") }} (CFS):</h3>
      </md-toolbar>
      <br />
    </div>

    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text" style="display: block;background: grey;">
            <h4 class="title">{{ $t("List of CFS") }}</h4>
          </div>
        </md-card-header>
        <!--<md-card-header class="md-card-header-text md-primary" style="background-color: #0ABAB5;">
          <div class="card-text" style="display: block;">
            <h3 class="md-title" style="color: white;">{{ $t("Canada Flight Supplement") }} (CFS)</h3>
          </div>
        </md-card-header>-->
        <md-card-content>
          <md-table
            :value="airportlists"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">{{ $t("Per page") }}</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="(item, position) in pagination.perPageOptions"
                    :key="position"
                    :label="item"
                    :value="item"
                    >{{ item }}</md-option
                  >
                </md-select>
              </md-field>

              <md-field>
                <md-input
                  type="search"
                  class="mb-3"
                  clearable
                  style="width: 200px"
                  :placeholder="$t('Search')"
                  v-model="searchQuery"
                ></md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              v-if="
                item.properties.CFS_LINK !== '' ||
                  item.properties.CFS_LINK_FR !== ''
              "
            >
              <md-table-cell :md-label="$t('Airport Code')" md-sort-by="id">{{
                item.id
              }}</md-table-cell>
              <md-table-cell :md-label="$t('Name')" md-sort-by="name">{{
                item.properties.NAME
              }}</md-table-cell>
              <md-table-cell :md-label="$t('Province')" md-sort-by="province">{{
                item.properties.PROVINCE
              }}</md-table-cell>
              <md-table-cell :md-label="$t('Type')" md-sort-by="Type"
                >{{ item.properties.TYPE }} -
                {{ item.properties.OPR_TYPE }}</md-table-cell
              >
              <md-table-cell :md-label="$t('PDF - EN')">
                <md-button
                  class="md-just-icon md-simple md-primary"
                  v-if="item.properties.CFS_LINK !== ''"
                >
                  <a target="blank" :href="CFS_URL + item.properties.CFS_LINK">
                    <md-icon>picture_as_pdf</md-icon>
                  </a>
                </md-button>
              </md-table-cell>
              <md-table-cell :md-label="$t('PDF - FR')">
                <md-button
                  class="md-just-icon md-simple md-primary"
                  v-if="item.properties.CFS_LINK_FR !== ''"
                >
                  <a
                    target="blank"
                    :href="CFS_URL + item.properties.CFS_LINK_FR"
                  >
                    <md-icon>picture_as_pdf</md-icon>
                  </a>
                </md-button>
              </md-table-cell>
              <md-table-cell :md-label="$t('FIR')">{{
                item.properties.FIR
              }}</md-table-cell>
              <md-table-cell :md-label="$t('FIR Contact')">{{
                item.properties.FIR_CONTACT
              }}</md-table-cell>
            </md-table-row>
          </md-table>
          <!--<div class="footer-table md-table">
            <table>
              <tfoot>
                <tr>
                  <th v-for="item in footerTable" :key="item.properties.NAME" class="md-table-head">
                    <div class="md-table-head-container md-ripple md-disabled ">
                      <div class="md-table-head-label">{{ item }}</div>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>-->
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              {{
                $t("Showing") +
                  " " +
                  (pagination.total === 0
                    ? 0
                    : (pagination.currentPage - 1) * pagination.perPage + 1) +
                  " " +
                  $t("to") +
                  " " +
                  (pagination.currentPage * pagination.perPage >
                  pagination.total
                    ? pagination.total
                    : pagination.currentPage * pagination.perPage) +
                  " " +
                  $t("of") +
                  " " +
                  pagination.total +
                  " " +
                  $t("entries")
              }}
            </p>
          </div>
          <pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            @pageChange="onPagination"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { Pagination } from "@/components";
import swal from "sweetalert2";
import { CFS_URL } from "@/helpers";
import { router } from "../../main";
import { USER_TYPE } from "@/const.js";
import { getAirportlists } from "@/services/airport.service";
import { debounce } from "@/helpers/utils";

export default {
  components: {
    Pagination
  },
  computed: {
    ...mapFields("auth", ["usertype", "plan_type"])
  },
  data() {
    return {
      CFS_URL: CFS_URL,
      USER_TYPE: USER_TYPE,
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 25, 50, 100],
        total: 0
      },
      //footerTable: ["Airport Code", "Name", "Province", "Type", "CFS PDF", "FIR", "FIR Contact"],
      searchQuery: "",
      airportlists: [],
      debouncedSearch: debounce(this.getAirportlistsFn, 300)
    };
  },
  methods: {
    async getAirportlistsFn(currentPage = 1, perPage = 10, keywords) {
      const { data, total } = await getAirportlists({
        current_page: currentPage,
        per_page: perPage,
        keywords
      });
      this.airportlists = data;
      this.pagination = {
        perPage,
        currentPage,
        perPageOptions: [10, 25, 50, 100],
        total
      };
    },
    onPagination(currentPage) {
      this.getAirportlistsFn(
        currentPage,
        this.pagination.perPage,
        this.searchQuery
      );
    }
  },
  beforeMount() {
    if (this.usertype === USER_TYPE.FREE) {
      swal
        .fire({
          title: this.$t("Warning"),
          text: this.$t("Free user cannot access this page."),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        })
        .then(() => {
          router.push("/dashboard");
        });
    }
    let { currentPage, perPage } = this.pagination;
    this.getAirportlistsFn(currentPage, perPage);
  },
  watch: {
    searchQuery(value) {
      let { perPage } = this.pagination;
      this.pagination.currentPage = 1;
      this.debouncedSearch(1, perPage, value);
    },
    "pagination.perPage": function(perPage) {
      this.pagination.currentPage = 1;
      this.getAirportlistsFn(1, perPage, this.searchQuery);
    }
  }
};
</script>

<style lang="css">
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
.theme-orange .vdatetime-popup__header,
.theme-orange .vdatetime-calendar__month__day--selected > span > span,
.theme-orange .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #ff9800;
}

.theme-orange .vdatetime-year-picker__item--selected,
.theme-orange .vdatetime-time-picker__item--selected,
.theme-orange .vdatetime-popup__actions__button {
  color: #ff9800;
}
</style>
